import { FindPublicRequestByTokenInput } from "@/Schemas/PublicRequest/FindPublicRequestByTokenInput";
import { FindPublicRequestBySearchInput } from "@/Schemas/PublicRequest/FindPublicRequestBySearchInput";
import {
    PublicRequestValidateOutput,
    PublicRequestValidateOutputSchema,
} from "@/Schemas/PublicRequest/PublicRequestValidateOutput";
import { SubmitPublicRequestInput } from "@/Schemas/PublicRequest/SubmitPublicRequestInput";
import {
    PublicRequestOutput,
    PublicRequestOutputSchema,
} from "@/Schemas/PublicRequest/PublicRequestOutput";
import { DownloadRequestDocumentInput } from "@/Schemas/PublicRequest/DownloadRequestDocumentInput";

import axios from "@/axios";
import { parseSchema } from "@/Utils/zodParser";

export const findContractByToken = async (
    input: FindPublicRequestByTokenInput
): Promise<PublicRequestValidateOutput> => {
    const url = '/api/public-request/ValidateRequest';
    const response = await axios.post(url, input);
    return parseSchema(PublicRequestValidateOutputSchema, { ...response.data });
};

export const findContractBySearch = async (
    input: FindPublicRequestBySearchInput
): Promise<PublicRequestValidateOutput> => {
    const url = '/api/public-request/ValidateRequest';
    const response = await axios.post(url, input);
    return parseSchema(PublicRequestValidateOutputSchema, { ...response.data });
};

export const submitPublicRequest = async (
    input: SubmitPublicRequestInput
): Promise<PublicRequestOutput> => {
    const url = '/api/public-request/CreateAndSubmitRequest';
    const response = await axios.post(url, input);
    return parseSchema(PublicRequestOutputSchema, { ...response.data });
};

export const downloadRequestDocument = async (
    input: DownloadRequestDocumentInput,
    fileName: string
): Promise<void> => {
    const url = '/api/public-request/StreamRequestDocumentFile';
    const response = await axios.post(url, input, { responseType: "blob" });
    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = fileName || "file";
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
}
